import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { SKIP_ERROR_TOAST, SKIP_AUTH_LOGOUT } from './http-context.tokens';
import { catchError, throwError } from 'rxjs';
import { AuthService } from './auth.service';
import { ToastService } from '../shared/toast/toast.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const toast = inject(ToastService);

  return next(req).pipe(
    catchError((error) => {
      // El backend (NestJS) devuelve { message } como string o como array (validaciones).
      const raw = error?.error?.message;
      const backendMsg = Array.isArray(raw) ? raw.join(', ') : raw;

      // Solo cerrar sesión en un 401 de una sesión YA activa y fuera del flujo de
      // autenticación. Si no, un código 2FA incorrecto (o un login fallido) — que el
      // backend responde como 401 — echaría al usuario en medio del flujo.
      const url = req.url;
      const esFlujoAuth =
        url.includes('/auth/login') ||
        url.includes('/auth/register') ||
        url.includes('/auth/totp');
      // Flujos que manejan el error en el componente con un mensaje genérico fijo
      // (recupero de password) no deben surfacear el mensaje del backend: anti-enumeración.
      const skipToast = req.context.get(SKIP_ERROR_TOAST);
      // Step-up de aprobaciones: el 401 es parte del flujo (segundo factor requerido /
      // código incorrecto), no una sesión muerta. No deslogueamos: lo maneja el modal.
      // `skipAuthLogout` cubre el desafío/verificación; el match por mensaje cubre el
      // PATCH decidir (preservando el logout ante un 401 de sesión expirada genuina).
      const skipAuthLogout = req.context.get(SKIP_AUTH_LOGOUT);
      const esStepUp401 = error.status === 401 && backendMsg === 'Step-up requerido';
      if (
        error.status === 401 &&
        auth.isAuthenticated() &&
        !esFlujoAuth &&
        !skipAuthLogout &&
        !esStepUp401
      ) {
        auth.logout();
      } else if (skipToast) {
        // El componente muestra su propio mensaje genérico; no toasteamos acá.
      } else if (error.status === 403) {
        toast.error('No tiene permisos para realizar esta accion');
      } else if (error.status === 400 || error.status === 422) {
        toast.error(backendMsg || 'Datos invalidos. Revise el formulario');
      } else if (error.status === 409) {
        toast.error(backendMsg || 'Conflicto: el recurso ya existe o esta en uso');
      } else if (error.status === 0) {
        toast.error('Error de conexion. Verifique su red');
      } else if (error.status >= 500) {
        toast.error('Error del servidor. Intente nuevamente');
      }
      return throwError(() => error);
    }),
  );
};
